<div [formGroup]="form">
  <h4
    id="{{ baseId }}-insurance-carrier-procedure-code-mapping-subtitle"
    translate
  >Insurance Carrier Procedure-Code Mapping</h4>

  <table
    class="table emds-table table-striped table-borderless mt-2"
    formGroupName="ProcedureCodeMapping"
  >
    <thead>
      <tr>
        <th></th>
        <th style="width: 50%">Map Item To</th>
        <th style="width: 50%">Substitution Text</th>
        <th></th>
      </tr>
    </thead>
    <tbody
      #dropList
      cdkDropList
      (cdkDropListDropped)="reorder($event)"
    >
      <tr
        *ngFor="let row of procedureCodeMappingFormArray.controls; index as i"
        [formGroupName]="i"
        cdkDrag
        [cdkDragBoundary]="dropList"
        id="{{ baseId }}-row-{{ i }}"
      >
        <div *cdkDragPreview></div>
        <td>
          <mat-icon
            cdkDragHandle
            class="material-icons"
          >drag_handler</mat-icon>
        </td>
        <td>
          <ap-findcontrol
            id="{{ baseId }}-row-{{ i }}-map-item-to"
            controlName="procedureCodePk"
            findControlDisplayName="Find Procedure Code"
            [selectedPks]="getProcedureCodeControl(i).value"
            [baseId]="baseId"
            [form]="form"
            [apFormGroup]="procedureCodeMappingFormArray.at(i)"
            [formGroupSubmitted]="isSubmitted"
            [singleSelect]="true"
            [formGroupSubmitted]="true"
            [findControlId]="findControlIdService.ListProcedure"
            (chipsChange)="procedureCodeChanged()"
          >
          </ap-findcontrol>
        </td>
        <td>
          <div class="form-group">
            <input
              id="{{ baseId }}-row-{{ i }}-substitution-text"
              type="text"
              class="form-control"
              [ngClass]="{ error: showErrors(getSubstitutionTextControl(i)) }"
              [maxlength]="500"
              formControlName="substitutionText"
            />
            <div
              *ngIf="showErrors(getSubstitutionTextControl(i))"
              id="{{ baseId }}-warning-text-country"
              class="incorrect-input"
              translate
            >
              {{ getSubstitutionTextControl(i).errors | fcListValidation : 'Substitution Text'
              }}
            </div>
          </div>
        </td>
        <td>
          <div class="emds icons-container">
            <a
              *ngIf="deleteRowButtonVisible(i)"
              role="button"
              title="close"
              (click)="deleteProcedureMappingRow(i)"
            >
              <mat-icon class="material-icons">close</mat-icon>
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
